import {onBlockLoaded} from "@plaudit/frontend-apis";

import "../../includes/extensions/blocks/plaudit-query-loop/viewScript";
import {notYetManaged} from "../../lib/utils";

function makeListItemBuilder(template: HTMLTemplateElement) {
	const templateRoot = template.content.firstElementChild!;
	return (field: plaudit.queryLoop.QueryLoopFormField): HTMLElement[] => {
		return field.getLabeledValues(true).map(labeledValue => {
			const itemRoot = templateRoot.cloneNode(true) as HTMLElement;
			itemRoot.setAttribute("data-field-name", labeledValue.field);
			itemRoot.setAttribute("data-field-value", labeledValue.value);
			const fieldLabelElement = itemRoot.querySelector('.field');
			let displayedValue = labeledValue.label;
			let labelValue = (labeledValue.fieldLabel ?? field.getLabel()).trim();
			while (labelValue.endsWith(':')) {
				labelValue = labelValue.substring(0, labelValue.length - 1).trim();
			}

			if (fieldLabelElement && labelValue) {
				fieldLabelElement.append(labelValue, ':');
				const match = new RegExp(`^${labelValue}\\W(.*)$`).exec(displayedValue)?.[1];
				if (match) {
					displayedValue = match;
				}
			}
			const ariaLabeledComponent = itemRoot.querySelector("[aria-label]");
			if (ariaLabeledComponent?.ariaLabel) {
				ariaLabeledComponent.ariaLabel = ariaLabeledComponent.ariaLabel.replaceAll("{displayed_value}", displayedValue).replaceAll("{field_label}", labelValue);
			}
			itemRoot.querySelector('.value')?.append(displayedValue);
			return itemRoot;
		});
	}
}

function attachSelectedFilterView(element: HTMLElement) {
	if (notYetManaged(element)) {
		const updateDelay = parseInt(element.getAttribute('data-update-delay') || '1000');
		const wrapper = element.closest('.plauditQueryLoop__selectedFilterValues');

		const template = element.closest('.plauditQueryLoop__selectedFilterValues')?.querySelector('.plauditQueryLoop__selectedFieldValueTemplate');
		if (template instanceof HTMLTemplateElement) {
			const listItemBuilder = makeListItemBuilder(template);
			const pqlForm = plaudit.queryLoop.forms.get(element);
			const rebuildSelectedItems = () => {
				// This ensures that we don't keep trying to update detached filter value lists
				if (!pqlForm.form.contains(element)) {
					pqlForm.form.removeEventListener('queryLoopFormValueChange', rebuildSelectedItems);
					pqlForm.form.removeEventListener('queryLoopFormInitialized', rebuildSelectedItems);
					return;
				}

				const selectedItems = pqlForm.getFields().flatMap(listItemBuilder);
				if (wrapper) {
					wrapper.setAttribute('data-total-selected-filter-values', selectedItems.length.toString());
				}
				element.replaceChildren(...selectedItems);
			};

			pqlForm.form.addEventListener('queryLoopFormValueChange', rebuildSelectedItems);
			pqlForm.form.addEventListener('queryLoopFormInitialized', rebuildSelectedItems);
			rebuildSelectedItems();
		}

		element.addEventListener('click', e => {
			if (e.target instanceof HTMLElement && (e.target.classList.contains('remove') || element.contains(e.target.closest(".remove")))) {
				const dataElement = e.target.closest('.selectedFieldValue');
				if (dataElement) {
					e.stopPropagation();
					const fieldName = dataElement.getAttribute('data-field-name');
					const fieldValue = dataElement.getAttribute('data-field-value');
					if (fieldName && fieldValue) {
						plaudit.queryLoop.forms.get(e.target).removeValueFromField(fieldName, fieldValue,
							element.querySelectorAll('.selectedFieldValue').length > 1 ? updateDelay : 0);
						dataElement.remove();
						if (wrapper) {
							wrapper.setAttribute('data-total-selected-filter-values',
								element.querySelectorAll('.selectedFieldValue').length.toString());
						}
					}
				}
			}
		});
	}
}

onBlockLoaded("plauditQueryLoop__selectedFilterValuesList", attachSelectedFilterView);
